<template>
  <section id="filter-custom">
    <div>
    </div>
    <div v-for="(item, index) in filters" :key="item.id">
      <span class="filter-title">{{ item.title }}：</span>
      <span v-for="child in item.children" 
            :key="child.value" 
            class="filter-item"
            :class="{'arrow-down':index === 2&&down[child.type]&&!isChecked[child.type],
                    'arrow-up':index === 2&&!down[child.type]&&!isChecked[child.type],
                    'arrow-down-check':index === 2&&down[child.type]&&isChecked[child.type],
                    'arrow-up-check':index === 2&&!down[child.type]&&isChecked[child.type],
                    'checked': isChecked[child.type]&&index !== 2}"
            @click="focusChange(child)"
            >{{ child.text }}</span>

      <ux-divider v-if="index !== 2" :dashed="true" />
    </div>
  </section>
</template>
<script>
import { filters } from './config'

export default {
  data() {
    return {
      filters: filters,
      isChecked: {
        'markFormula': false,
        'openTender': false,
        'orientTender': false,
        'publishT': false,
        'deadlineT': false
      },
      down: {
        publishT: true,
        deadlineT: true
      }
    }
  },
  methods: {
    focusChange(option) {
      if(option.type === 'publishT' || option.type === 'deadlineT') {
        if(this.isChecked[option.type]) {
          this.down[option.type] = !this.down[option.type];

        } else {
          this.isChecked[option.type] = !this.isChecked[option.type]
        }
        this.resetUncheck(option.type);
      } else {
         this.isChecked[option.type] = !this.isChecked[option.type]
      }
     
      this.$emit('filterChange', {
          option, 
          checked: this.isChecked[option.type],
          sort: this.down[option.type]
        });
    },
    resetUncheck(type) {
      Object.keys(this.down).forEach((key) => {
        if(type !== key) {
          this.down[key] = true;
          this.isChecked[key] = false;
        }
      })
      console.log(this.down, this.isChecked)
    }
  }
}
</script>

<style scoped>
#filter-custom {
  background: #fff;
  padding: 12px 20px;
}
#filter-custom >>> .ux-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
}
.filter-title {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  display: inline-block;
  margin-right: 30px;
}
.filter-item {
  display: inline-block;
  margin-right: 40px;
  font-size: 12px;
  color: #333333;
  line-height: 20px;
  cursor: pointer;
  padding: 2px 20px 2px 8px;
}
.arrow-down{
  position: relative;
}
.arrow-down-check {
  position: relative;
  background: #4285F4;
  color: #fff;
}
.arrow-down-check:before {
  content: '';
  display: inline-block;
  height: 10px;
  border-left: solid 1px #fff;
  position: absolute;
  right: 8.9px;
  top: 5px;
}
.arrow-down-check:after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-left: solid 1px #fff;
  border-bottom: solid 1px #fff;
  transform: rotate(-45deg);
  position: absolute;
  right: 5.4px;
  top: 7px
}
.arrow-down:before {
  content: '';
  display: inline-block;
  height: 10px;
  border-left: solid 1px #333333;
  position: absolute;
  right: 8.9px;
  top: 5px;
}
.arrow-down:after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-left: solid 1px #333333;
  border-bottom: solid 1px #333333;
  transform: rotate(-45deg);
  position: absolute;
  right: 5.4px;
  top: 7px
}
.arrow-up {
  position: relative;
}
.arrow-up-check {
  position: relative;
  background: #4285F4;
  color: #fff;
}
.arrow-up-check:before {
  content: '';
  display: inline-block;
  height: 10px;
  border-left: solid 1px #fff;
  position: absolute;
  right: 8.9px;
  top: 7px;
}
.arrow-up-check:after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: solid 1px #fff;
  border-top: solid 1px #fff;
  transform: rotate(-45deg);
  position: absolute;
  right: 5.4px;
  top: 7px
}
.arrow-up:before {
  content: '';
  display: inline-block;
  height: 10px;
  border-left: solid 1px #333333;
  position: absolute;
  right: 8.9px;
  top: 7px;
}
.arrow-up:after {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: solid 1px #333333;
  border-top: solid 1px #333333;
  transform: rotate(-45deg);
  position: absolute;
  right: 5.4px;
  top: 7px
}
.checked {
  background: #4285F4;
  color: #fff;
  position: relative;
}
.checked::before {
  content: '';
  height: 9px;
  display: inline-block;
  border-left: solid 1px #fff;
  position: absolute;
  transform: rotate(45deg);
  top:7px;
  right: 10px;
}
.checked:after {
  content: '';
  height: 9px;
  display: inline-block;
  border-left: solid 1px #fff;
  position: absolute;
  transform: rotate(-45deg);
  top:7px;
  right: 10px;
}
</style>